import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Gateway from "@/pages/Gateway";
import Tarquinio from "@/pages/Tarquinio";
import BBQ from "@/pages/BBQ";
import { LangProvider } from "@/i18n/LangContext";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Gateway />} />
            <Route path="/tarquinio" element={<Tarquinio />} />
            <Route path="/bbq" element={<BBQ />} />
          </Routes>
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
